import { FC, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './Feedback.module.css';

export type Props = {
  children: ReactNode | undefined;
  type?: 'success' | 'error';
};

export const Feedback: FC<Props> = ({ type = 'success', children }) => (
  <div className={clsx(styles.chatFeedback, styles[type])}>
    <p>{children}</p>
  </div>
);
